import Wrapper from "../../Layout/Wrapper/wrapper";
import { Title } from "../../atoms/Title/title";
import classnames from "classnames";
import "./styles.scss";

interface SectionProps {
  id: string;
  hero?: string;
  background?: {
    mobile: string;
    tablet: string;
    desktop: string;
  };
  title?: string;
  titleTag?: string;
  heroTitle?: boolean;
  subtitle?: string;
  content?: string;
  component?: string;
  className: string;
  overlay?: string;
  backgroundColor?: string;
  imageOverlay?: string;
  imageGradient?: string;
  twoCols?: string;
  centered?: string;
  secondContent?: string;
}

const Section = ({
  id,
  hero,
  background,
  title,
  titleTag,
  heroTitle,
  subtitle,
  content,
  component,
  className,
  backgroundColor,
  overlay,
  imageOverlay,
  imageGradient,
  twoCols,
  centered,
  secondContent,
}: SectionProps) => {
  const classNames = classnames("section", {
    [className]: className,
    "section--hero": hero,
    "section--overlay": overlay || imageOverlay,
    "section--imageOverlay": imageOverlay,
    "section--imageGradient": imageGradient,
    "section--hasBackground": background,
    "section--twoCols": twoCols,
    "section--centered": centered,
  });

  return (
    <section
      id={id}
      style={{ backgroundColor: backgroundColor }}
      className={`${classNames} section--${id}`}>
      {background && (
        <img
          className="section__bgImage"
          src={`${background.desktop}`}
          srcSet={`
            ${background.mobile} 420w, 
            ${background.tablet} 720w, 
            ${background.desktop} 1280w,
          `}
          alt={title}
        />
      )}
      <Wrapper>
        {title && (
          <Title
            medium={heroTitle ? false : true}
            hero={heroTitle ? true : false}
            tag={titleTag}
            content={title}
          />
        )}
        {subtitle && (
          <div
            className="section__subtitle"
            dangerouslySetInnerHTML={{ __html: subtitle }}></div>
        )}
        {content && (
          <div
            className="section__content"
            dangerouslySetInnerHTML={{ __html: content }}></div>
        )}
        {component && component}
        {secondContent && (
          <div
            className="section__secondContent"
            dangerouslySetInnerHTML={{ __html: secondContent }}></div>
        )}
      </Wrapper>
    </section>
  );
};

export default Section;
